import React from 'react'

import { checkNull } from 'utils/utils'
const parts = ['', 'هزار', 'میلیون', 'میلیارد', 'تریلیون', 'کوادریلیون', 'کویینتیلیون', 'سکستیلیون'];
const numbers = {
  0: ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'],
  1: ['', 'ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'],
  2: ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'],
  two: ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'],
  zero: 'صفر',
};
const delimiter = ' و ';

const latinToPersianMap = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰'];
const persianToLatinMap = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
const latinNumbers = [/1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g, /0/g];
const persianNumbers = [/۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g, /۰/g];
const arabicToPersianMap = ['۴', '۵', '۶'];
const arabicNumbers = [/٤/g, /٥/g, /٦/g];



export function latinToPersian(words) {
  if (checkNull(words))
    return words
  else {
  //   if (words.toString().includes(':') && words.length === 3) {
  //     let firstPart = words.splt(':')[0].toString().padStart(2,"0");
  //     let secondPart = words.splt(':')[1].toString().padStart(2,"0");
  //     words = `${firstPart}:${secondPart}`
  //   }
      // words = words === "0:0" ? "00:00" :  words;

    if (words == "") return words;
    let result = words;

    for (let index = 0; index < 10; index++) {
      result = result.replace(latinNumbers[index], latinToPersianMap[index]);
    }

    return result;
  }
}

export function persianToLatin(string) {
  if (checkNull(string))
    return string
  else {
    if (string == "") return string;
    let result = string;

    for (let index = 0; index < 10; index++) {
      result = result.replace(persianNumbers[index] , persianToLatinMap[index] );
    }

    return result;
  }
}

export function arabicToPersian(string) {
  let result = string;

  for (let index = 0; index < 10; index++) {
    result = result.replace(arabicNumbers[index], arabicToPersianMap[index]);
  }

  return result;
}

export function getDayNameByIndex(dayNumber) {
  var days = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه'];
  return days[dayNumber];
}

export function getDayName() {
  return getDayTitleUsingLatinDate(new Date());
  // var days = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه'];
  // let getday = new Date().getDay();
  // if ((getday + 1) == 7) getday = 0
  // return days[getday];
}


export function getDayTitle(date) {
  return getDayTitleUsingLatinDate(new Date(date));
  // var days = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه'];
  // let getday = new Date(date).getDay();

  // // if ((getday + 1) == 7) getday = 0
  // if (getday >= 7) getday = 0
  // return days[getday];

}

export function getDayTitleUsingLatinDate(date) {
  const options = { weekday: 'long' };
  var localDate = new Date(date);
  return localDate.toLocaleDateString("fa-IR", options).trim();
}


export function getDayNumber(day) {
  var days = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه'];

  for (var i = 0; i < days.length; i++) {
    if (days[i].toString().replace(/\s/g, '') == day.toString().replace(/\s/g, '')) {
      return i;
    }
  }
}


// Add comma to every 3 number
export function formatNumber(number, dec = false) {
  number = number.toFixed(2) + '';
  let x = number.split('.');
  let x1 = x[0];
  let x2 = x.length > 1 ? '.' + x[1] : '';
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + (dec ? x2 : '');
}

export function formatString(string, dec = false) {
  const numberString = React.isNumber(parseInt(string)) && string !== '' ? string : 0;
  return formatNumber(parseInt(numberString), dec) + '';
}

export function removeCommasFromString(string) {
  return string.split(',').join('');
}

export function convert(input) {
  let string = input + ''; // covert to string.

  string = string.split('')
    .reverse()
    .join('')
    .replace(/\d{3}(?=\d)/g, '$&,')
    .split('')
    .reverse()
    .join('')
    .split(',')
    .map((separated) => Array(4 - separated.length).join('0') + separated);

  let result = [];
  for (let iThree = 0; iThree < string.length; iThree++) {
    const three = string[iThree];
    let resultThree = [];

    for (let index = 0; index < three.length; index++) {
      const digit = three[index];
      if (index === 1 && digit === '1') {
        resultThree.push(numbers.two[three[2]]);
      } else if ((index !== 2 || three[1] !== '1') && numbers[index][digit] !== '') {
        resultThree.push(numbers[index][digit]);
      }
    }

    resultThree = resultThree.join(delimiter);
    result.push(resultThree + ' ' + parts[string.length - iThree - 1]);
  }

  result = result.filter(part => part.trim() !== '').join(delimiter).trim();

  if (result === '') {
    result = numbers.zero;
  }

  return result;
}
